@if (hasAnyCurrentMatches) {
<!-- options list -->
<p class="h4 m-b-4">{{label}}</p>
<div class="p-l-2">
    <div class="flex">
        <div class="w-12-s m-b-4-x m-b-4-l">
            <div [grid]="isSwatch ? 2 : undefined"
                 [gridColumnGap]="isSwatch ? '40px' : '8px'"
                 [gridRowGap]="isSwatch ? '24px' : '16px'"
                 [style.column-gap.px]="4"
                 [style.row-gap.px]="16"
                 [ngClass]="[!isSwatch ? 'flex flex-wrap' : '', !isSizeAttribute && !isColorAttribute ? 'flex-column' : '']">
                @for (option of sortedOptionsWithMatches(); track $index; let isLast = $last) {
                <div (click)="toggle(option)"
                     class="flex flex-middle _filter-option cursor-pointer"
                     [style.white-space]="'nowrap'">
                    <!--           [gtmTrackFilterClick]="{filter: filter, option: option}" -->
                    <href [link]="getOptionLink(option)">
                        @switch (true) {
                        @case(isColorAttribute) {
                        <swatch [option]="option"
                                [selected]="isSelected(option)"
                                [optionBig]="true"
                                class="inline-block va-m m-r-2"></swatch>
                        <span class="p2 col-1">{{option.label}}</span>
                        }
                        @case(isSizeAttribute) {
                        <div class="b-a b-col-42 p-a-3"
                             [class.bg-col-11]="isSelected(option)">
                            <span class="p2"
                                  [class.col-w]="isSelected(option)">{{option.label}}</span>
                        </div>
                        }
                        @default {
                        <checkbox [checked]="isSelected(option)">
                            <span class="p-l-2 p1 col-11">{{option.label}}
                                <span class="col-12">&nbsp;|&nbsp;{{getCurrentMatchesCount(option)}}</span>
                            </span>
                        </checkbox>
                        }
                        }
                    </href>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}